


















































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { PaginationPanel, DataPanel } from "@/components";
import SearchPanel from "@/components/SearchPanel.vue";
import { formRules, vform } from "@/common/util/validator";
import dayjs from 'dayjs';
import { Public } from "@/http/api_Public";
import { fmoney } from "@/common/util/money";
var fileDownload = require("js-file-download");
@Component({
  components: {
    SearchPanel,
    DataPanel,
    PaginationPanel,
  },
})
export default class employeeBilling extends Vue {
  fmoney = fmoney;
  timeValue = [dayjs(new Date()).startOf("month").format("YYYY-MM-DD"),dayjs(new Date()).endOf("month").format("YYYY-MM-DD")];
  /**登陆信息 */
  public userInfo = JSON.parse(localStorage.getItem("userInfo"));
  /**正则方法 */
  public formRules: any = formRules;
  /**请求加载判断 */
  public loading: boolean = false;
  // 右对齐
  public labelPosition: string = "right";
  /**刷新 */
  public rePagin: boolean = false;
  /**列表数据 */
  public listData = [];
  /**数据总数 */
  public total: number = 0;

  totalForm = {};
  exloading = false;
  public $refs!: {
    form: HTMLFormElement;
  };
  // 搜索字段
  public searchValue = {
    shopId: JSON.parse(localStorage.getItem("userInfo")).shopId,
    start: dayjs(new Date()).startOf("month").format("YYYY-MM-DD") + " " + "00:00:00",
    end: dayjs(new Date()).endOf("month").format("YYYY-MM-DD") + " " + "23:59:59",
    nameJobNumber: "",
    skip: 0,
    count: 10,
  };
  async mounted() {
    await this.getlist();
  }
  activated() {}
  // beforeDestroy(){
  //     window.removeEventListener('handleEnter',this.handleSearch,false) //离开当前路由，会直接调用beforeDestroy方法销毁回车事件
  // }

  /**获取列表信息 */
  public async getlist() {
    this.loading = true;
    let result = await Public.GetEmployeeOverview(this.searchValue);
    this.listData = result.item2.map(v=>{
      return {
        ...v,
        createTime:dayjs(v.createTime).format("YYYY-MM-DD")
      }
    });
    this.total = result.item1.total;
    let result2 = await Public.GetEmployeeOverviewTotal(this.searchValue);
    this.totalForm = result2;
    this.$nextTick(() => {
      this.loading = false;
    });
  }
  // 点击搜索
  public async handleSearch() {
    this.rePagin = false;
    Object.assign(this.searchValue, { skip: 0, count: 10 });
    await this.getlist();
    this.rePagin = true;
  }
  // 重置
  public async onReset() {
    this.rePagin = false;
    this.timeValue = [dayjs(new Date()).startOf("month").format("YYYY-MM-DD"),dayjs(new Date()).endOf("month").format("YYYY-MM-DD")];
    this.searchValue = {
      shopId: JSON.parse(localStorage.getItem("userInfo")).shopId,
      start: dayjs(new Date()).startOf("month").format("YYYY-MM-DD") + " " + "00:00:00",
      end: dayjs(new Date()).endOf("month").format("YYYY-MM-DD") + " " + "23:59:59",
      nameJobNumber: "",
      skip: 0,
      count: 10,
    };
    await this.getlist();
    this.rePagin = true;
  }
  public async onPaginationChange(page) {
    let { skip, count } = page;
    Object.assign(this.searchValue, { skip, count });
    await this.getlist();
  }
  /**时间改变 */
  timeChange(val) {
    if (val) {
      this.searchValue.start = val[0] + " " + "00:00:00";
      this.searchValue.end = val[1]+ " " + "23:59:59";
    } else {
      this.searchValue.start = "";
      this.searchValue.end = "";
    }
  }
  /**统计合计 */
  getSummaries(param) {
    const { columns, data } = param;
    const sums:any = [];
    let sumTotal = this.jsHj();

    columns.forEach((column, index) => {
        if (index === 0) {
            sums[index] = `合计`;
            return;
        }
        sums[index] = sumTotal[column.property];
    });

    return sums;
  }
  jsHj() {
    let form = {
        count: '',
        num: '',
        receivables:'',
        returnNum:'',
        totalRefunded:'',
        actualTotal:'',
        rechargeCount:'',
        rechargeAmount:'',
        giftAmount:'',
    },
    arr = this.listData;
    if (arr.length > 0) {
        form = {
          count: this.totalForm['count'],
          num: this.totalForm['num'],
          receivables:fmoney(this.totalForm['receivables'],2),
          returnNum:this.totalForm['returnNum'],
          totalRefunded:fmoney(this.totalForm['totalRefunded'],2),
          actualTotal:fmoney(this.totalForm['actualTotal'],2),
          rechargeCount:this.totalForm['rechargeCount'],
          rechargeAmount:fmoney(this.totalForm['rechargeAmount'],2),
          giftAmount:fmoney(this.totalForm['giftAmount'],2),
        };
    }
    return form;
  }
  export_table() {
    try {
      this.exloading = true;
      Public.GetEmployeeOverviewReport(Object.assign({},this.searchValue,{
        skip:0,
        count:-1
      })).then((res) => {
        var fileName = "员工开单明细";
        fileDownload(res.data, fileName + ".xls");
        this.exloading = false;
      });
    } catch (error) {
      this.exloading = false;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/employeeBilling/index.vue